
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./godwoken-swap-sdk.cjs.production.min.js')
} else {
  module.exports = require('./godwoken-swap-sdk.cjs.development.js')
}
